import React from 'react';
import PropTypes from 'prop-types';

const BackLink = ({ handleOnclick, text }) => (
    <div className="outbound clearfix">
        <button type="button" className="outbound-link pull-left pl-0 pb-3" onClick={() => handleOnclick()}>
            <span className="icon chevron-blue chevron-left" /> {text}
        </button>
    </div>
);

BackLink.propTypes = {
    handleOnclick: PropTypes.func,
    text: PropTypes.string,
};

BackLink.defaultProps = {
    text: 'Back to overview',
};

export default BackLink;
